// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.alert {
  margin-top: 20px;
}

.product-manage h1 {
  line-height: 4rem;
}
.product-manage section {
  margin-bottom: 30px;
}
.product-manage i {
  display: block;
  margin: 0 auto;
}
.product-manage h2 {
  margin-bottom: 20px;
  margin-top: 30px;
}
.product-manage hr {
  margin: 0;
}
.product-manage .create-assign a {
  display: inline-block;
  margin: 30px 0;
}
.product-manage .create-assign a i {
  font-size: 50px;
}
.product-manage .create-assign .create-user {
  text-align: left;
}
.product-manage .create-assign .assign-unassign {
  text-align: center;
}
.product-manage .create-assign .change-product {
  text-align: center;
}
.product-manage .create-assign .change-product i {
  text-align: center;
}
.product-manage .license-status {
  margin-top: 5px;
}
.product-manage .license-status .status {
  display: inline;
}

.popup-header {
  padding: 30px;
  position: relative;
}
.popup-header h2 {
  font-size: 30px;
  font-weight: normal;
  margin: 0;
  outline: none;
  padding: 0;
}

.popup-body {
  padding: 0 30px 20px;
}
.popup-body hr {
  margin: 20px 0;
}
.popup-body h2 {
  font-size: 30px;
  margin-bottom: 20px;
  margin-top: 0;
}
.popup-body .current-prod {
  margin-bottom: 10px;
}
.popup-body .form-group {
  margin-bottom: 0;
}
.popup-body .assign-prod label {
  margin-bottom: 5px;
}
.popup-body .prod-desc {
  padding-right: 5px;
}
.popup-body .input-text {
  padding: 0;
}
.popup-body .new {
  width: 100%;
}
.popup-body .text-danger {
  margin-bottom: 0;
}

.popup-footer {
  border-radius: 8px;
  bottom: 0;
  padding: 0 30px;
  position: relative;
  width: 100%;
}
.popup-footer .btn-click {
  float: right;
  margin-left: 30px;
}
.popup-footer hr {
  margin: 30px 0 20px;
}
.popup-footer a {
  margin-bottom: 20px;
}

@media (max-width: 1024px) {
  .product-manage .create-assign a {
    display: block;
  }
  .license-status b {
    display: block;
    text-align: right;
  }
  .license-status .status {
    display: block !important;
  }
  .create-user {
    text-align: center !important;
  }
  .change-product {
    margin-bottom: 20px !important;
    margin-top: 0 !important;
    text-align: center !important;
  }
  .modal-header {
    padding: 15px 15px 30px !important;
  }
  .modal-header h2 {
    font-size: 18px;
  }
  .modal-body {
    padding: 0 15px 30px !important;
  }
  .modal-body .unassign-user {
    margin-bottom: 30px;
  }
  .modal-footer {
    background: white;
    padding: 0 15px !important;
  }
  .modal-footer hr {
    margin: 20px 0;
  }
  .modal-footer button {
    width: 100%;
  }
  .modal-footer a {
    margin-bottom: 30px !important;
    margin-top: 0 !important;
    width: 100%;
  }
  .popup-header {
    padding: 15px 15px 30px;
  }
  .popup-header h2 {
    font-size: 18px;
  }
  .popup-body {
    max-height: 145px;
    overflow: auto;
    padding: 0 15px;
  }
  .popup-body .marketing {
    margin-left: 15px;
  }
  .popup-body h2 {
    font-size: 18px;
  }
  .popup-footer {
    background: white;
    padding: 0 15px;
  }
  .popup-footer hr {
    margin: 20px 0;
  }
  .popup-footer a {
    margin-top: 20px;
  }
  .btn {
    width: 100%;
  }
}
.modal-header {
  padding: 30px;
  position: relative;
}
.modal-header h2 {
  font-size: 30px;
  font-weight: normal;
  margin: 0;
  outline: none;
  padding: 0;
}

.modal-body {
  padding: 0 30px 20px;
}
.modal-body hr {
  margin: 20px 0;
}
.modal-body h2 {
  font-size: 30px;
  margin-bottom: 20px;
}

.modal-footer {
  border-radius: 0;
  bottom: 0;
  padding: 0 30px;
  position: relative;
  width: 100%;
}
.modal-footer .btn-click {
  float: right;
  margin-left: 30px;
}
.modal-footer a {
  margin: 20px 0;
}
.modal-footer button {
  margin: 20px 0 20px 20px;
}
.modal-footer hr {
  margin: 0;
}

.unassign-user {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-product/manage-product.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,gBAAA;AAkJF;;AA7IE;EACE,iBAAA;AAgJJ;AA7IE;EACE,mBAAA;AA+IJ;AA5IE;EACE,cAAA;EACA,cAAA;AA8IJ;AA3IE;EACE,mBAAA;EACA,gBAAA;AA6IJ;AA1IE;EACE,SAAA;AA4IJ;AAtII;EACE,qBAAA;EACA,cAAA;AAwIN;AAtIM;EACE,eAAA;AAwIR;AApII;EACE,gBAAA;AAsIN;AAnII;EACE,kBAAA;AAqIN;AAlII;EACE,kBAAA;AAoIN;AAlIM;EACE,kBAAA;AAoIR;AA/HE;EACE,eAAA;AAiIJ;AA/HI;EACE,eAAA;AAiIN;;AA5HA;EACE,aAAA;EACA,kBAAA;AA+HF;AA7HE;EACE,eAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;AA+HJ;;AA3HA;EACE,oBAAA;AA8HF;AA5HE;EACE,cAAA;AA8HJ;AA3HE;EACE,eAAA;EACA,mBAAA;EACA,aAAA;AA6HJ;AA1HE;EACE,mBAAA;AA4HJ;AAzHE;EACE,gBAAA;AA2HJ;AAvHI;EACE,kBAAA;AAyHN;AArHE;EACE,kBAAA;AAuHJ;AApHE;EACE,UAAA;AAsHJ;AAnHE;EACE,WAAA;AAqHJ;AAlHE;EACE,gBAAA;AAoHJ;;AAhHA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AAmHF;AAjHE;EACE,YAAA;EACA,iBAAA;AAmHJ;AAhHE;EACE,mBAAA;AAkHJ;AA/GE;EACE,mBAAA;AAiHJ;;AFxOI;EE8HE;IACE,cAAA;EA8GN;EAxGE;IACE,cAAA;IACA,iBAAA;EA0GJ;EAvGE;IACE,yBAAA;EAyGJ;EArGA;IACE,6BAAA;EAuGF;EApGA;IACE,8BAAA;IACA,wBAAA;IACA,6BAAA;EAsGF;EAnGA;IACE,kCAAA;EAqGF;EAnGE;IACE,eAAA;EAqGJ;EAjGA;IACE,+BAAA;EAmGF;EAjGE;IACE,mBAAA;EAmGJ;EA/FA;IACE,iBAAA;IACA,0BAAA;EAiGF;EA/FE;IACE,cAAA;EAiGJ;EA9FE;IACE,WAAA;EAgGJ;EA7FE;IACE,8BAAA;IACA,wBAAA;IACA,WAAA;EA+FJ;EA3FA;IACE,uBAAA;EA6FF;EA3FE;IACE,eAAA;EA6FJ;EAzFA;IACE,iBAAA;IACA,cAAA;IACA,eAAA;EA2FF;EAzFE;IACE,iBAAA;EA2FJ;EAxFE;IACE,eAAA;EA0FJ;EAtFA;IACE,iBAAA;IACA,eAAA;EAwFF;EAtFE;IACE,cAAA;EAwFJ;EArFE;IACE,gBAAA;EAuFJ;EAnFA;IACE,WAAA;EAqFF;AACF;AAlFA;EACE,aAAA;EACA,kBAAA;AAoFF;AAlFE;EACE,eAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;AAoFJ;;AAhFA;EACE,oBAAA;AAmFF;AAjFE;EACE,cAAA;AAmFJ;AAhFE;EACE,eAAA;EACA,mBAAA;AAkFJ;;AA9EA;EACE,gBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AAiFF;AA/EE;EACE,YAAA;EACA,iBAAA;AAiFJ;AA9EE;EACE,cAAA;AAgFJ;AA7EE;EACE,wBAAA;AA+EJ;AA5EE;EACE,SAAA;AA8EJ;;AA1EA;EACE,mBAAA;AA6EF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n//manage product style starts here\n.alert {\n  margin-top: 20px;\n}\n\n.product-manage {\n\n  h1 {\n    line-height: 4rem;\n  }\n\n  section {\n    margin-bottom: 30px;\n  }\n\n  i {\n    display: block;\n    margin: 0 auto;\n  }\n\n  h2 {\n    margin-bottom: 20px;\n    margin-top: 30px;\n  }\n\n  hr {\n    margin: 0;\n  }\n\n  .create-assign {\n\n\n    a {\n      display: inline-block;\n      margin: 30px 0;\n\n      i {\n        font-size: 50px;\n      }\n    }\n\n    .create-user {\n      text-align: left;\n    }\n\n    .assign-unassign {\n      text-align: center;\n    }\n\n    .change-product {\n      text-align: center;\n\n      i {\n        text-align: center;\n      }\n    }\n  }\n\n  .license-status {\n    margin-top: 5px;\n\n    .status {\n      display: inline;\n    }\n  }\n}\n\n.popup-header {\n  padding: 30px;\n  position: relative;\n\n  h2 {\n    font-size: 30px;\n    font-weight: normal;\n    margin: 0;\n    outline: none;\n    padding: 0;\n    }\n  }\n\n.popup-body {\n  padding: 0 30px 20px;\n\n  hr {\n    margin: 20px 0;\n  }\n\n  h2 {\n    font-size: 30px;\n    margin-bottom: 20px;\n    margin-top: 0;\n  }\n\n  .current-prod {\n    margin-bottom: 10px;\n  }\n\n  .form-group {\n    margin-bottom: 0;\n  }\n\n  .assign-prod {\n    label {\n      margin-bottom: 5px;\n    }\n  }\n\n  .prod-desc {\n    padding-right: 5px;\n  }\n\n  .input-text {\n    padding: 0;\n  }\n\n  .new {\n    width: 100%;\n  }\n\n  .text-danger {\n    margin-bottom: 0;\n  }\n}\n\n.popup-footer {\n  border-radius: 8px;\n  bottom: 0;\n  padding: 0 30px;\n  position: relative;\n  width: 100%;\n\n  .btn-click {\n    float: right;\n    margin-left: 30px;\n   }\n\n  hr {\n    margin: 30px 0 20px;\n  }\n\n  a {\n    margin-bottom: 20px;\n  }\n}\n\n@include respond-to (small) {\n  .product-manage {\n    .create-assign {\n      a {\n        display: block;\n      }\n    }\n  }\n\n  .license-status {\n    b {\n      display: block;\n      text-align: right;\n    }\n\n    .status {\n      display: block !important;\n    }\n  }\n\n  .create-user {\n    text-align: center !important;\n  }\n\n  .change-product {\n    margin-bottom: 20px !important;\n    margin-top: 0 !important;\n    text-align: center !important;\n  }\n\n  .modal-header {\n    padding: 15px 15px 30px !important;\n\n    h2 {\n      font-size: 18px;\n    }\n  }\n\n  .modal-body {\n    padding: 0 15px 30px !important;\n\n    .unassign-user {\n      margin-bottom: 30px;\n   }\n  }\n\n  .modal-footer {\n    background: color(default, light);\n    padding: 0 15px !important;\n\n    hr {\n      margin: 20px 0;\n    }\n\n    button {\n      width: 100%;\n    }\n\n    a {\n      margin-bottom: 30px !important;\n      margin-top: 0 !important;\n      width: 100%;\n    }\n  }\n\n  .popup-header {\n    padding: 15px 15px 30px;\n\n    h2 {\n      font-size: 18px;\n    }\n  }\n\n  .popup-body {\n    max-height: 145px;\n    overflow: auto;\n    padding: 0 15px;\n\n    .marketing {\n      margin-left: 15px;\n    }\n\n    h2 {\n      font-size: 18px;\n    }\n  }\n\n  .popup-footer {\n    background: color(default, light);\n    padding: 0 15px;\n\n    hr {\n      margin: 20px 0;\n    }\n\n    a {\n      margin-top: 20px;\n    }\n  }\n\n  .btn {\n    width: 100%;\n  }\n}\n\n.modal-header {\n  padding: 30px;\n  position: relative;\n\n  h2 {\n    font-size: 30px;\n    font-weight: normal;\n    margin: 0;\n    outline: none;\n    padding: 0;\n    }\n  }\n\n.modal-body {\n  padding: 0 30px 20px;\n\n  hr {\n    margin: 20px 0;\n  }\n\n  h2 {\n    font-size: 30px;\n    margin-bottom: 20px;\n  }\n}\n\n.modal-footer {\n  border-radius: 0;\n  bottom: 0;\n  padding: 0 30px;\n  position: relative;\n  width: 100%;\n\n  .btn-click {\n    float: right;\n    margin-left: 30px;\n   }\n\n  a {\n    margin: 20px 0;\n  }\n\n  button {\n    margin: 20px 0 20px 20px;\n  }\n\n  hr {\n    margin: 0;\n  }\n}\n\n.unassign-user {\n  margin-bottom: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
